import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import type { User } from 'oidc-client-ts';
import type { FC, PropsWithChildren } from 'react';
import { AuthProvider, type AuthProviderProps } from 'react-oidc-context';
import { CapacitorNavigator } from './CapacitorNavigator';
import { CapacitorStorage } from './CapacitorStorage';
import { bpUserManager } from './utils/userManager';

export const BpAuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const isNative = Capacitor.isNativePlatform();

  const manager = isNative
    ? bpUserManager.setUserManager(new CapacitorStorage(), new CapacitorNavigator())
    : bpUserManager.setUserManager(window.sessionStorage);

  const oidcConfig: AuthProviderProps = {
    userManager: manager,
    onSigninCallback: (_user: User | void): void => {
      // Clear auth tokens from URL for security
      window.history.replaceState({}, document.title, window.location.pathname);
      if (isNative) {
        Browser.close();
      }
    },
  };

  return (
    <>
      <AuthProvider {...oidcConfig}>{children}</AuthProvider>
    </>
  );
};
